// Full-document render of the sealy UtilityPage: PageSkeleton (the React
// document shell) wrapping the utility content.
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { UtilityLeftSideBarList } from "../blocks/UtilityLeftSideBarList";
import { UtilityRightSideBarList } from "../blocks/UtilityRightSideBarList";
import { PageSkeleton } from "../components/PageSkeleton";
import { UtilityPageBody } from "../components/UtilityPageBody";

export const leftSideBarComponents = {
    nav_link_lists: UtilityLeftSideBarList,
} as const;

export const rightSideBarComponents = {
    nav_link_lists: UtilityRightSideBarList,
} as const;

// Container col classes by which side-navs are present. Right-only falls
// through to a bare "container".
const containerClass = (hasLeft: boolean, hasRight: boolean): string => {
    if (hasLeft && !hasRight) {
        return "container container__col container__col--2";
    }
    if (hasLeft && hasRight) {
        return "container container__col container__col--3";
    }
    if (!hasLeft && !hasRight) {
        return "container promotions ptb";
    }
    return "container";
};

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed
// with mutable reactivated props (see PageSkeleton). The body/side-nav
// StreamFields accept both.
export const Template = (
    props: templates.UtilityPageTemplate,
): React.JSX.Element => {
    const leftBar = props.page.left_side_nav_bar;
    const rightBar = props.page.right_side_nav_bar;
    const hasLeft = !!leftBar;
    const hasRight = !!rightBar;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="utility">
                <div className={containerClass(hasLeft, hasRight)}>
                    {leftBar && (
                        <aside>
                            <StreamField
                                tagName={React.Fragment}
                                value={leftBar.body.value}
                                components={leftSideBarComponents}
                            />
                        </aside>
                    )}
                    <div className="content">
                        <UtilityPageBody value={props.page.body.value} />
                    </div>
                    {rightBar && (
                        <aside>
                            <div className="sidekick sidekick--border">
                                <h4 className="sidekick__header">
                                    {rightBar.title ?? ""}
                                </h4>
                                {rightBar.body && (
                                    <StreamField
                                        tagName={React.Fragment}
                                        value={rightBar.body.value}
                                        components={rightSideBarComponents}
                                    />
                                )}
                            </div>
                        </aside>
                    )}
                </div>
            </div>
        </PageSkeleton>
    );
};
